import { Link } from "react-router-dom";
import { Lock, ArrowRight, Info, Wrench, MessageCircle, AlertTriangle } from "lucide-react";
import { PHOTOS, JEREMY } from "@/lib/jeremy";

export default function CustomerLoginPage() {
  return (
    <main className="pt-28 md:pt-36 pb-24 min-h-screen bg-[#FDFBF7]" data-testid="customer-login-page">
      <div className="max-w-2xl mx-auto px-4 sm:px-6">
        <div className="card-warm p-8 md:p-10">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-[#D97706] shrink-0">
              <img src={PHOTOS.character} alt="Jeremy" className="w-full h-full object-cover object-top" />
            </div>
            <div>
              <div className="eyebrow">Customer Portal</div>
              <h1 className="mt-1 font-serif-display text-3xl md:text-4xl font-semibold text-[#0F382C]">
                Welcome back. Jeremy and the ION team are here to help.
              </h1>
            </div>
          </div>

          <p className="text-slate-600">
            Track. Monitor. Connect. The existing-customer portal is coming in the next release. Real-time updates, 24/7 monitoring, and direct access to Jeremy.
          </p>

          <div className="mt-6 flex items-start gap-3 rounded-2xl bg-[#F7F4EB] border border-[#E5E0D8] p-4">
            <Info className="w-4 h-4 text-[#B45309] shrink-0 mt-0.5" />
            <div className="text-xs text-slate-600 leading-relaxed">
              Portal, secure authentication, and admin dashboard are scoped for the next build phase per project agreement.
            </div>
          </div>

          <div className="mt-8 space-y-3">
            <div className="text-xs uppercase tracking-widest font-mono-metric text-slate-500 mb-2">Who handles what</div>
            <div className="rounded-2xl border border-[#E5E0D8] p-4 flex items-start gap-3">
              <MessageCircle className="w-4 h-4 text-[#D97706] mt-1 shrink-0" />
              <div>
                <div className="font-serif-display text-base text-[#0F382C]">Jeremy personally assists with</div>
                <div className="text-sm text-slate-600">Bill review, qualification questions, HOA paperwork, agreement walkthroughs, and status updates.</div>
              </div>
            </div>
            <div className="rounded-2xl border border-[#E5E0D8] p-4 flex items-start gap-3">
              <Wrench className="w-4 h-4 text-[#0F382C] mt-1 shrink-0" />
              <div>
                <div className="font-serif-display text-base text-[#0F382C]">ION handles</div>
                <div className="text-sm text-slate-600">Installation, technical service, monitoring, and warranty support.</div>
              </div>
            </div>
            <div className="rounded-2xl border border-red-200 bg-red-50 p-4 flex items-start gap-3">
              <AlertTriangle className="w-4 h-4 text-red-600 mt-1 shrink-0" />
              <div>
                <div className="font-serif-display text-base text-red-800">Urgent system or safety issues</div>
                <div className="text-sm text-red-700">Contact ION's official support channels immediately. For emergencies, call 911.</div>
              </div>
            </div>
          </div>

          <Link to="/" className="mt-8 btn-solar w-full justify-center" data-testid="customer-login-home-link">
            Back to home <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </main>
  );
}
